class FormsSwitcher extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabs = document.querySelectorAll(".forms-switcher__button");
    this.forms = document.querySelectorAll(".forms-switcher__form-item");
    this.tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => this.setActive(index));
    });
  }

  setActive(index) {
    this.tabs.forEach((tab) =>
      tab.classList.remove("forms-switcher__button--active")
    );

    this.forms.forEach((form) =>
      form.classList.remove("forms-switcher__form-item--active")
    );

    this.tabs[index].classList.add("forms-switcher__button--active");
    this.forms[index].classList.add("forms-switcher__form-item--active");
  }
}

customElements.define("forms-switcher", FormsSwitcher);
